import { configValues } from 'utils/appConfig'

export default configValues.customIcon
